<!--
  Custom gantt-elastic task row that renders a horizontal bar plus a label.
  gantt-elastic renders a task row component by its `type` name, so a task with
  `type: 'GanttTask'` resolves to this component.

  The label is placed after the bar by default, or before the bar when
  `task.labelPosition === 'left'` (used for the second bar so its label is less
  likely to overflow the right edge of the panel).
-->
<template>
  <g class="gantt-elastic__chart-row-bar-wrapper gantt-elastic__chart-row-task-wrapper">
    <svg
      class="gantt-elastic__chart-row-bar gantt-elastic__chart-row-task"
      :x="task.x"
      :y="task.y"
      :width="task.width"
      :height="task.height"
      :viewBox="`0 0 ${task.width} ${task.height}`"
      xmlns="http://www.w3.org/2000/svg"
    >
      <polygon
        class="gantt-elastic__chart-row-bar-polygon gantt-elastic__chart-row-task-polygon"
        :style="barStyle"
        :points="`0,0 ${task.width},0 ${task.width},${task.height} 0,${task.height}`"
      ></polygon>
    </svg>
    <svg
      class="gantt-elastic__chart-row-text-wrapper"
      :style="root.style['chart-row-text-wrapper']"
      :x="labelX"
      :y="task.y - gap"
      :width="getLabelWidth()"
      :height="labelHeight"
    >
      <foreignObject
        x="0"
        y="0"
        width="100%"
        :height="labelHeight"
      >
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          class="gantt-elastic__chart-row-text"
          :style="root.style['chart-row-text']"
        >
          <div
            class="gantt-elastic__chart-row-text-content gantt-elastic__chart-row-text-content--text"
            :style="textContentStyle"
          >
            <div>{{ task.label }}</div>
          </div>
        </div>
      </foreignObject>
    </svg>
  </g>
</template>

<script>
export default {
  name: 'GanttTask',
  inject: ['root'],
  props: ['task'],
  computed: {
    gap() {
      return this.root.state.options.chart.grid.horizontal.gap;
    },
    labelHeight() {
      return this.task.height + this.gap * 2;
    },
    labelX() {
      const offset = this.root.state.options.chart.text.offset;
      if (this.task.labelPosition === 'left') {
        return this.task.x - offset - this.getLabelWidth();
      }
      return this.task.x + this.task.width + offset;
    },
    barStyle() {
      return {
        ...this.root.style['chart-row-bar-polygon'],
        ...this.root.style['chart-row-task-polygon'],
        ...this.task.style.base,
        ...this.task.style['chart-row-bar-polygon']
      };
    },
    textContentStyle() {
      return {
        ...this.root.style['chart-row-text-content'],
        ...this.root.style['chart-row-text-content--text'],
        height: '100%',
        'line-height': this.labelHeight + 'px'
      };
    }
  },
  methods: {
    getLabelWidth() {
      const textStyle = this.root.style['chart-row-text'];
      this.root.state.ctx.font = `${textStyle['font-weight']} ${textStyle['font-size']} ${textStyle['font-family']}`;
      const textWidth = this.root.state.ctx.measureText(this.task.label).width;
      return textWidth + this.root.state.options.chart.text.xPadding * 2;
    }
  }
};
</script>
